import * as T from '../types';

/**
 * The apply request from what is ticked on the screen. `unticked` holds the catalog items whose change line the user
 * unticked: an addition left out ("já tenho em casa") or a change or removal that leaves the list as it is.
 */
export function applyRequest(
  changes: T.ShoppingChange[],
  unticked: T.Guid[],
  missing: T.Guid[],
  restored: T.Guid[],
): T.ApplyMealPlanShoppingRequest {
  const off = (c: T.ShoppingChange) => unticked.includes(c.catalogItemPublicId);
  return {
    missingPantryItemPublicIds: missing,
    leftOutItemPublicIds: changes.filter(c => c.action === 'Add' && off(c)).map(c => c.catalogItemPublicId),
    restoredItemPublicIds: restored,
    keptItemPublicIds: changes.filter(c => c.action !== 'Add' && off(c)).map(c => c.catalogItemPublicId),
  };
}
